export const Label = ({ children }: { children: React.ReactNode }) => <span style={{ color: "gray" }}>{children}</span>;
